import { render, staticRenderFns } from "./contractDept.vue?vue&type=template&id=3cb48518&scoped=true"
import script from "./contractDept.vue?vue&type=script&lang=js"
export * from "./contractDept.vue?vue&type=script&lang=js"
import style0 from "./contractDept.vue?vue&type=style&index=0&id=3cb48518&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb48518",
  null
  
)

export default component.exports